module.exports = __webpack_public_path__ + "img/csi-page-tabs-image-2.40a31fb3.jpg";